import axios from 'axios'

export interface SessionConfig {
  hostname: string
  brand: string
}

export interface SessionClient {
  createSession: () => Promise<string>
  getSessionFromForm: (request: SessionFormRequest & { brand: string }) => Promise<string>
  getSessionFromToken: (
    request: SessionTokenRequest & { brand: string },
  ) => Promise<string>
}

export interface SessionResponse {
  accessToken: string
}

export interface SessionFormRequest {
  externalReference: string
  dateOfBirth: string
  postalCode: string
}

export interface SessionTokenRequest {
  token: string
}

export const isTokenRequest = (
  request: SessionTokenRequest | SessionFormRequest,
): request is SessionTokenRequest => Object.hasOwn(request, 'token')

export const createSessionClient = ({ hostname }: SessionConfig): SessionClient => {
  const instance = axios.create({
    baseURL: `${hostname}/api`,
  })

  instance.defaults.headers.common.Accept = 'application/json'

  instance.defaults.headers.post['Content-Type'] = 'application/json'

  return {
    createSession: async () => {
      const { data } = await instance.post<SessionResponse>('/session')
      return data.accessToken
    },
    getSessionFromForm: async (request) => {
      const { data } = await instance.post<SessionResponse>('/session/form', request)
      return data.accessToken
    },
    getSessionFromToken: async (request) => {
      const { data } = await instance.post<SessionResponse>('/session/token', request)
      return data.accessToken
    },
  }
}
